<template>
  <div class="diLink">
      <Rectangle name="管理员信息"   />   
    <div>
        <el-form
          ref="userForm"
          :rules="rules"
          :model="userFormModel"
        >
        <el-table :data="tableData" border :span-method="arraySpanMethod"  @selection-change="handleSelectionChange">
          <el-table-column
            v-if="!isDetail"
            width="55">
            <template slot-scope="scope">
              <el-checkbox
              v-if="scope.$index!=4"
              :disabled="userInfoCheckStatus[scope.row.dataProperty].checkDisabled"
              v-model="userInfoCheckStatus[scope.row.dataProperty].checked"
              @change="checkUserInfo(scope.$index, scope.row)">
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            width="150"
            label="变更类别">
          </el-table-column>

          <el-table-column
            prop="origin"
            width="250"
            label="修改前信息">
            <template slot-scope="scope" >
              <el-form-item v-if="scope.$index==4">
                <el-input
                  :disabled="isDetail"
                  type="textarea"
                  maxlength="100"
                  :rows="4"
                  @input="inputInfo"
                  placeholder="请输入内容"
                  v-model.trim="tableData[scope.$index].changeto">
                </el-input>
             </el-form-item>
              <span v-else-if="scope.$index==1">{{getCertTypeName(tableData[scope.$index].origin)}}</span>
              <span v-else>{{tableData[scope.$index].origin}}</span>
              <div class="link-style" v-if="scope.$index == 3" @click="toApealChangePage">这个手机号已失效?</div>
            </template>
          </el-table-column>
          <el-table-column
            label="修改后信息">
            <template slot-scope="scope">
              <el-form-item
               v-if="scope.$index==1"
               :prop="scope.row.dataProperty"
              >
                <el-select

                  :disabled="!userInfoCheckStatus[scope.row.dataProperty].checked"
                  v-model.trim="tableData[scope.$index].changeto"
                  placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :prop="scope.row.dataProperty" v-else>
              <el-input
                
                :disabled="scope.$index !=4 && !userInfoCheckStatus[scope.row.dataProperty].checked"
                v-model.trim="tableData[scope.$index].changeto" 
                class="userinfo-input">
              </el-input>
              </el-form-item >
              <el-checkbox
                v-if="scope.$index==0"
                :disabled="!userInfoCheckStatus['userName'].checked"
                v-model="isOrganizer"
                @change="checkOrganizer"
                class="ml20">
                同步法定代表人信息
               </el-checkbox>
            </template>
          </el-table-column>
        </el-table>
        </el-form>
    </div> 
    <!--
    <div class="tc mt50">
        <el-button type="primary" size="medium" class="mr10" @click="toNext">下一步</el-button>
        <el-button
        v-if="!isDetail"
        :disabled="!(userInfoCheckStatus.userName.checked ||
        userInfoCheckStatus.userName.checked||
        userInfoCheckStatus.certType.checked||
        userInfoCheckStatus.certNo.checked||
        userInfoCheckStatus.phoneNo.checked)"
        type="primary"
        size="medium"
        class="mr10"
        @click="doSubmit">提交审核</el-button>
        <el-button  size="medium" @click="back">返回</el-button>
    </div>
    -->
  </div>
</template>

<script>
import { CERT_TYPE_LIST } from '@/utif/constant';
import { getImageUrl } from "@/http/upload.js";

const authFileList = [
        {text: "授权委托书（盖公章和法人签章）",originFileId:"", fileId:"", dataProperty:"authFile", errorMsg:"请上传授权委托书（盖公章和法人签章）"},
        {text: "管理员身份证复印件（盖公章）", originFileId:"", fileId:"", dataProperty:"certFaceId", errorMsg:"请上传管理员身份证复印件（盖公章）"},
        {text: "营业执照复印件（盖公章）", originFileId:"", fileId:"", dataProperty:"businessLicenceId", errorMsg:"请上传营业执照复印件（盖公章）"},
        {text: "法人代表身份证复印件（盖公章和法人签章）", originFileId:"", fileId:"", dataProperty:"lawCertFaceId", errorMsg:"请上传法人代表身份证复印件（盖公章和法人签章）"}
      ];

export default {
  props:['detail','isDetail'],
  data(){
    return{
      options: CERT_TYPE_LIST,
      value: '',
      //stepList:['信息修改','平台验证'],
      isOrganizer:false,//是否法定代表人
      tableData: [] ,
      userInfoFiles:[],
      authFiles: this.detail.changeto.authFiles,
      userInfoFilesVisible:false,
      userInfo:'',
      userInfoCheckStatus:{
        userName:{checked:false, checkDisabled:false},
        certType:{checked:false, checkDisabled:false},
        certNo:{checked:false, checkDisabled:false},
        phoneNo:{checked:false, checkDisabled:false}
      },
      authFileStatus: {
        authFile: {visible: false},
        certFaceId: {visible: false},
        businessLicenceId: {visible: false},
        lawCertFaceId:{visible:false}
      },
      rules: {
        userName: [
          //{ required: true, message:"请输入姓名", trigger:'blur'},
          { validator: this.checkUserName, trigger: 'blur'}
        ],
        certType: [
          //{ required: true, message:"请选择证件类型", trigger:'change'},
          { validator: this.checkCertType, trigger: 'blur'}
        ],
        certNo: [
          //{ required: true, message:"请输入证件号码", trigger:'blur' },
          { validator: this.checkCertNo, trigger: 'blur'}
        ],
        phoneNo: [
          //{ required: true, message:"请输入手机号码", trigger:'blur' },
          { validator: this.checkPhoneNo, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    console.log("isDetail", this);
  },
  methods:{
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if(rowIndex==4){
        if(columnIndex==1 && this.isDetail ){
          return [1,2];
        }

        if(columnIndex==2 && !this.isDetail) {
          return [1,2];
        }
      }
    },
    handleSelectionChange(val){
      
    },
    checkUserInfo(index, row) {
      //this.userInfoCheckStatus[row.dataProperty].disabled = !this.userInfoCheckStatus[row.dataProperty].checked;
      //debugger

      const changeToUserDetail =  this.detail.changeto.userInfo;
      const originUserDetail = this.detail.origin.userInfo;
      if(index == 0) {
        if(this.userInfoCheckStatus["userName"].checked) {
        //1, 1)勾选姓名，证件姓名，证件号码，手机号码默认都勾选
          if(originUserDetail.userName == changeToUserDetail.userName) {
            this.tableData[0].changeto ='';
          }

          this.userInfoCheckStatus["certType"].checked = true;
          this.userInfoCheckStatus["certType"].checkDisabled = true;
          if(originUserDetail.certType == changeToUserDetail.certType) {
            this.tableData[1].changeto ='0';
          }
          
          this.userInfoCheckStatus["certNo"].checked = true;
          this.userInfoCheckStatus["certNo"].checkDisabled = true;
          if(originUserDetail.certNo == changeToUserDetail.certNo) {
            this.tableData[2].changeto ='';
          }
          //debugger
          this.userInfoCheckStatus["phoneNo"].checked = true;
          if(originUserDetail.phoneNo == changeToUserDetail.phoneNo) {
            this.tableData[3].changeto ='';
          }

          this.userInfoCheckStatus["phoneNo"].checkDisabled = true;
          
        } else {
          this.tableData[0].changeto = changeToUserDetail.userName;
          
          this.userInfoCheckStatus["certType"].checkDisabled = false;
          this.userInfoCheckStatus["certType"].checked = false;
          this.tableData[1].changeto = changeToUserDetail.certType;
          
          this.userInfoCheckStatus["certNo"].checkDisabled = false;
          this.userInfoCheckStatus["certNo"].checked = false;
          this.tableData[2].changeto = changeToUserDetail.certNo;
          
          this.userInfoCheckStatus["phoneNo"].checkDisabled = false;
          this.userInfoCheckStatus["phoneNo"].checked = false;
          this.tableData[3].changeto = changeToUserDetail.phoneNo;

          this.isOrganizer = false;
        }
      }

      if(index == 1) {
        //1. 2)单选证件类型， 证件号码选项框默认勾选且置灰
        if(this.userInfoCheckStatus["certType"].checked) {
          if(originUserDetail.certType == changeToUserDetail.certType) {
            this.tableData[1].changeto ='0';
          }

          this.userInfoCheckStatus["certNo"].checkDisabled = true;
          this.userInfoCheckStatus["certNo"].checked= true;
          if(originUserDetail.certNo == changeToUserDetail.certNo) {
            this.tableData[2].changeto ='';
          }

        } else {
          this.tableData[1].changeto = changeToUserDetail.certType;

          this.userInfoCheckStatus["certNo"].checkDisabled = false;
          this.userInfoCheckStatus["certNo"].checked= false;
          this.tableData[2].changeto = changeToUserDetail.certNo;
        }
      }

      if(index == 2) {
        if(this.userInfoCheckStatus["certNo"].checked) {
          if(originUserDetail.certNo == changeToUserDetail.certNo) {
            this.tableData[2].changeto ='';
          }
        } else {
          this.tableData[2].changeto = changeToUserDetail.certNo;
        }
      }

      if(index == 3) {
        //debugger
        if(this.userInfoCheckStatus["phoneNo"].checked) {
          if(originUserDetail.phoneNo == changeToUserDetail.phoneNo) {
            this.tableData[3].changeto ='';
          }
          if(originUserDetail.phoneNo == changeToUserDetail.phoneNo) {
            this.tableData[3].changeto ='';
            //this.$set(this.tableData, 3, Object.assign({},{...this.tableData[3]},{changeto:''}));
          }
         
        } else {
          this.tableData[3].changeto = changeToUserDetail.phoneNo;
        }
      }

      if(this.userInfoCheckStatus["userName"].checked ||
        this.userInfoCheckStatus["certType"].checked ||
        this.userInfoCheckStatus["certNo"].checked) {
          // debugger
          this.$parent.userAuthFileStatus.authFile.visible = true;
          this.$parent.userAuthFileStatus.certFaceId.visible = true;
      } else {
          this.$parent.userAuthFileStatus.authFile.visible = false;
          this.$parent.userAuthFileStatus.certFaceId.visible = false;
      }

      if(this.$refs["userForm"]) {
        this.$refs["userForm"].clearValidate();
      }
      //this.checkChange();
    },
    checkOrganizer(checked) {
      //this.$emit('checkOrganizer', checked);
      if(checked) {
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        const currentCompanyNo = JSON.parse(sessionStorage.getItem('company')).companyNo;
        if(currentUser && currentUser.compInfos && currentUser.compInfos.length > 0) {
          const compInfoItems = currentUser.compInfos.filter(item => item.companyNo == currentCompanyNo);
          if(compInfoItems && compInfoItems.length > 0) {
            this.tableData[0].changeto = compInfoItems[0].organizerName;
            this.tableData[1].changeto = compInfoItems[0].certType;
            this.tableData[2].changeto = compInfoItems[0].certNo;
            this.tableData[3].changeto = compInfoItems[0].organizerPhone;
          }
        }
      } else {
          this.tableData[0].changeto = '';
          this.tableData[1].changeto = '0';
          this.tableData[2].changeto = '';
          this.tableData[3].changeto = '';
      }
      //this.checkUserInfo();
      //this.checkCompanyInfo();
    },
    // 保存填写信息
    saveFillInfo(){
      //debugger
      const userInfo = {
        "userName": this.tableData[0].changeto,
        "isOrganizer": this.isOrganizer?'Y':'N',
        "certType": this.tableData[1].changeto,
        "certNo": this.tableData[2].changeto,
        "phoneNo":this.tableData[3].changeto,
        "userChangeReason":this.tableData[4].changeto
        //"certFaceId":this.userInfoFiles.certFaceId,
        //"authFile": this.userInfoFiles.authFile
      };
      //let _this = this;
      //this.userInfoFiles.forEach(file => _this.authFiles[file.dataProperty] = file.fileId);
      //debugger
      //this.$emit('saveInfo','userInfo', userInfo);
      //this.$emit('saveInfo','fileInfo',this.authFiles);
      //this.setAuthFileStatus();
      //this.$parent.saveInfo('companyInfo',companyInfo);
      this.$parent.saveInfo('userInfo', userInfo);
    },
    setAuthFileStatus() {
      this.$emit('setAuthFileStatus', this.authFileStatus);
    },
    setAuthFiles(authFiles) {
      this.authFiles = authFiles;
      this.getUserInfoFileTableData();
    },
    back(){
      this.$emit("toBack");
    },
    toApealChangePage() {
      this.$router.push("/web-user-management/appeal-change/detail");
    },
    getCertTypeName(certType) {
      //debugger
      let certItems = CERT_TYPE_LIST.filter(certItem => certItem.value == certType);
      if(certItems.length > 0) {
        return certItems[0].label;
      }

      return certType;
    },
    initTableData(){
      this.tableData = [
        {
          type:'姓名',
          origin:this.detail.origin.userInfo.userName,
          changeto:this.detail.changeto.userInfo.userName,
          dataProperty: "userName",
        },
        {
          type:'证件类型',
          origin:this.detail.origin.userInfo.certType,
          changeto:this.detail.changeto.userInfo.certType,
          dataProperty: "certType",
        },
        {
          type:'证件号码',
          origin:this.detail.origin.userInfo.certNo,
          changeto:this.detail.changeto.userInfo.certNo,
          dataProperty: "certNo",
        },
        {
          type:'手机号码',
          origin:this.detail.origin.userInfo.phoneNo,
          changeto: this.detail.changeto.userInfo.phoneNo,
          dataProperty: "phoneNo",
        },
        {
          type:'变更原因',
          origin:this.detail.origin.userInfo.userChangeReason,
          changeto:this.detail.origin.userInfo.userChangeReason,
          dataProperty: "userChangeReason",
        },
      ]
      this.value = this.detail.changeto.userInfo.certType;
      this.isOrganizer = this.detail.changeto.userInfo.isOrganizer == 'Y';
    },
    checkUserName(rule, value, callback) {
      //debugger
      //console.log("checkUserName");
      if(!this.tableData[0].changeto) {
        return callback(new Error("请输入姓名"));
      }
      callback();
    },
    checkCertType(rule, value, callback) {
      console.log("checkCertType");
      if(!this.tableData[1].changeto) {
        return callback(new Error("请选择证件类型"));
      }
      callback();
    },
    checkCertNo(rule, value, callback) {
      if(!this.tableData[2].changeto) {
        return callback(new Error("请输入证件号码"));
      } else {
        if(this.tableData[0].origin != this.tableData[0].changeto) {
          if(this.tableData[2].origin == this.tableData[2].changeto) {
            return callback(new Error("更改了姓名，请更改证件号码"));
          }
        }
      }
      callback();
    },
    inputInfo (val) {
      console.log(val,val.length)
    },
    checkPhoneNo(rule, value, callback) {
      //if(!this.tableData[3].changeto) {
      //  return callback(new Error("请输入手机号码"));
      //}
      const newValue = this.tableData[3].changeto;
      if (newValue) {
        let reg = /^1\d{10}$/;
        if (!reg.test(value)) {
          return callback(new Error("请输入正确的手机号码"));
        }
      } else {
        return callback(new Error("请输入手机号"));
      }
      if(this.tableData[0].origin != this.tableData[0].changeto) {
        if(this.tableData[3].origin == this.tableData[3].changeto) {
          return callback(new Error("更改了姓名，请更改手机号码"));
        }
      }
      callback();
    },
    inputValidate() {
      let validatePass = true;
      const userForm = this.$refs.userForm;
       if(userForm) {
         userForm.validate((valid) => {
           validatePass = valid;
         });
       }
       return validatePass;
    }
  },
  computed: {
    userFormModel: function() {
      return {
        userName: this.tableData[0].changeto,
        certType: this.tableData[1].changeto,
        certNo  : this.tableData[2].changeto,
        phoneNo : this.tableData[3].changeto
      }
    },
    hasAnyChanged() {
      let hasAnyChange = false;
      for(let i = 0; i < this.tableData.length - 1; i++) {
        let dataItem = this.tableData[i];
        let detailChangetoUserInfo = this.detail.changeto.userInfo;
        if(dataItem.changeto != detailChangetoUserInfo[dataItem.dataProperty]) {
          hasAnyChange = true;
          break;
        }
      }
      return hasAnyChange;
    }
  },
  //todo remove this;当仅仅改动手机号时貌似检测不到变化
  watch: {

  },
  created(){
    this.initTableData();
    if(!this.isDetail) {
      for(let i =0;i<this.tableData.length;i++) {
        if(this.tableData[i].origin != this.tableData[i].changeto) {
          const dataProperty = this.tableData[i].dataProperty;
          this.userInfoCheckStatus[dataProperty].checked = true;
          this.checkUserInfo(i);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .userinfo-input{
    width: 220px;
    margin-right: 10px;
  }

  /deep/ .link-style {
      color: #E85326;
      //text-decoration: underline;
      cursor: pointer;
      font-size: 12px;
  }
  .ml20{
    margin-left: 0;
  }
  .tc{
   text-align: center;
  }
  /deep/ .mr10{
    margin-right: 10px;
  }
  .mt50{
    margin-top: 50px;
  }
  /deep/ .error-msg {
    color: red ;
  }
  /deep/ .el-form-item {
      margin-bottom: 0;
      .el-form-item__error {
        position:relative;
        display: inline-block;
      }
    }
</style>